module.exports = __webpack_public_path__ + "img/cards1_front49.7a121b9c.png";